import InvestmentProjects from "./InvestmentProjects"

export default InvestmentProjects
